import React, { useState, useEffect, useContext } from "react";
import { Store } from "react-notifications-component";
import { Row, Col, Form, Card, Button, Table } from "react-bootstrap";
import axios from "axios";
import { AutoComplete, Divider } from "rsuite";
import InputText from "../Elements/InputText.jsx";
import InputPassword from "../Elements/InputPassword.jsx";
import InputSelect from "../Elements/InputSelect.jsx";
import classes from "./NewUser.module.css";
import PermissionContext from "../../Store/permission-context";
import ModalOkay from "./Modals/ModalOkay";
var CryptoJS = require("crypto-js");
const NewUser = () => {
  const [Username, setUsername] = useState("");
  const [Surname, setSurname] = useState("");
  const [Firstname, setFirstname] = useState("");
  const [Middlename, setMiddlename] = useState("");
  const PCtx = useContext(PermissionContext);
  const [Gateway, setGateway] = useState("");
  const [RetypeGateway, setRetypeGateway] = useState("");
  const [Address, setAddress] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [Email, setEmail] = useState("");
  const [Category, setCategory] = useState("");
  const [AllUsers, setAllUsers] = useState("");
  const [AxiosError, setAxiosError] = useState("");

  const [ShowOkAlert, setShowOkAlert] = useState(false);
  const [Okmessage, setOkmessage] = useState("");
  const [Oktitle, setOktitle] = useState("");

  useEffect(() => {
    const getData = async () => {
      let Users = await PCtx.connectAxios("getallusers.php", "");
      setAllUsers(Users);
    };
    getData();
  }, []);

  const RegisterStaff = async (e) => {
    e.preventDefault();
    let AllTheUsers = [...AllUsers];
    if (AllTheUsers.includes(Username)) {
      PCtx.displayAlert(
        "ERROR",
        "Ooops! " +
          Username +
          " is already existing. Please Choose another Username",
        "danger",
      );
    } else {
      if (Gateway === RetypeGateway) {
        var scrambled = CryptoJS.AES.encrypt(
          Gateway,
          "143tonybridget",
        ).toString();

        //To decrypt
        // var bytes = CryptoJS.AES.decrypt(ciphertext, "143tonybridget");
        // var decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        // console.log(decryptedData);

        let staff = {
          Username: Username,
          Surname: Surname,
          Firstname: Firstname,
          Middlename: Middlename,
          Gateway: scrambled,
          Address: Address,
          PhoneNumber: PhoneNumber,
          Email: Email,
          Category: Category,
        };

        let Response = await PCtx.connectAxios("savenewstaff.php", staff);

        if (Response.includes("Success")) {
          setOkmessage(
            Username +
              " registered successfully. You can start using the software by login in with your Username and Password",
          );
          setOktitle("SUCCESS!");
          setShowOkAlert(true);
        }
      } else {
        PCtx.displayAlert(
          "ERROR",
          "The two password does not match. Please enter the same value in the Password and Retype Password fields",
          "danger",
        );
      }
    }
  };

  const nextOKEvent = () => {
    setShowOkAlert(false);
    window.location.href = PCtx.RealPath + "/#";
  };

  return (
    <Row>
      <Col md={12}>
        <Card>
          <Card.Body>
            <h5
              className="text-center "
              style={{ color: "brown", fontFamily: "Times New Roman" }}
            >
              <Divider className="m-0">NEW STAFF REGISTRATION FORM</Divider>
            </h5>
          </Card.Body>
        </Card>
      </Col>
      <Col md={12} sm={12} xs={12}>
        <Row className="justify-content-around my-5">
          <Col md={7} sm={11} xs={11}>
            <Card className={classes.Shadow}>
              <Card.Body>
                <h5
                  className="text-center"
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                >
                  Please fill in the information below. The fields marked (*)
                  are compulsory
                </h5>
                <Form className="py-5" onSubmit={RegisterStaff}>
                  <Row className="justify-content-around">
                    <Col md={4} sm={6} xs={6}>
                      <InputText
                        label="Username"
                        myName="Username"
                        myVal={Username}
                        myOnChange={setUsername}
                        Compulsory={true}
                        required={true}
                      />
                    </Col>
                    <Col md={4} sm={6} xs={6}>
                      <InputText
                        label="Surname"
                        myName="Surname"
                        myVal={Surname}
                        myOnChange={setSurname}
                        Compulsory={true}
                        required={true}
                      />
                    </Col>
                  </Row>
                  <Row className="justify-content-around">
                    <Col md={4} sm={6} xs={6}>
                      <InputText
                        label="Firstname"
                        myName="Firstname"
                        myVal={Firstname}
                        myOnChange={setFirstname}
                        Compulsory={true}
                        required={true}
                      />
                    </Col>
                    <Col md={4} sm={6} xs={6}>
                      <InputText
                        label="Middlename"
                        myName="Middlename"
                        myVal={Middlename}
                        myOnChange={setMiddlename}
                      />
                    </Col>
                  </Row>
                  <Row className="justify-content-around">
                    <Col md={4} sm={6} xs={6}>
                      <InputPassword
                        label="Password"
                        myName="Password"
                        myVal={Gateway}
                        myOnChange={setGateway}
                        Compulsory={true}
                        required={true}
                      />
                    </Col>
                    <Col md={4} sm={6} xs={6}>
                      <InputPassword
                        label="Retype Password"
                        myName="RetypePassword"
                        myVal={RetypeGateway}
                        myOnChange={setRetypeGateway}
                        required={true}
                        Compulsory={true}
                      />
                    </Col>
                  </Row>
                  <Row className="justify-content-around">
                    <Col md={4} sm={6} xs={6}>
                      <InputText
                        label="Phone Number"
                        myName="PhoneNumber"
                        myVal={PhoneNumber}
                        myOnChange={setPhoneNumber}
                      />
                    </Col>
                    <Col md={4} sm={6} xs={6}>
                      <InputText
                        label="Email"
                        myName="Email"
                        myVal={Email}
                        className={classes.Shadow}
                        myOnChange={setEmail}
                      />
                    </Col>
                  </Row>
                  <Row className="justify-content-around">
                    <Col md={4} sm={6} xs={6}>
                      <InputText
                        label="Address"
                        myName="Address"
                        myVal={Address}
                        myOnChange={setAddress}
                      />
                    </Col>
                    <Col md={4} sm={6} xs={6}>
                      <InputSelect
                        label="Staff Category"
                        myName="StaffCategory"
                        myOnChange={setCategory}
                        myVal={Category}
                        required={true}
                        Compulsory={true}
                        myOptions={["Select", "Regular", "Admin", "CEO"]}
                      />
                    </Col>
                  </Row>
                  <Row className="justify-content-center">
                    <Col md={4} sm={4} xs={4}>
                      <Button
                        type="submit"
                        variant="success"
                        className="w-100 mt-3"
                      >
                        Save
                      </Button>{" "}
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
      <ModalOkay
        message={Okmessage}
        okshow={ShowOkAlert}
        title={Oktitle}
        nextEvent={nextOKEvent}
      />
    </Row>
  );
};

export default NewUser;
